export const documentUploadFieldStyles = {
    container: {
        width: '100%',
    },
    sectionTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: '14px',
        color: '#111111',
        fontWeight: 'bold',
        marginBottom: '8px',
    },
    documentIcon: {
        width: '48px',
        height: '48px',
        objectFit: 'contain',
    },
    uploadText: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#333333',
        marginLeft: '8px',
    },
    documentRow: {
        display: 'flex',
        marginBottom: '8px',
        gap: '8px',
        alignItems: 'center',
    },
    grayCircle: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        backgroundColor: '#F5F5F5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '12px',
        color: '#666666',
        fontSize: '14px',
    },
    selectContainer: {
        width: '250px',
    },
    uploadButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        '& .anticon': {
            fontSize: '16px',
        },
    },
    customFlex: {
        display: 'flex',
        alignItems: 'center',
    },
    addDocumentButton: {
        cursor: 'pointer',
        '&:hover': {
            color: '#40A9FF',
        },
    },
    helpText: {
        color: '#666666',
        fontSize: '12px',
        marginTop: '8px',
    },
    uploadContainer: {
        '& .ant-upload-list': {
            display: 'none',
        },
    },
};
